import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import Header from "./components/header";

const Guard = () => {
    const token = localStorage.getItem('token');
    return token ? <><Header /><Outlet /></> : <Navigate to="/login" />
};

export default Guard